import { cn } from '~/chords/lib/cn';

import { Icon } from '../Icon';

interface ChevronIconProps {
  direction?: 'up' | 'down';
}

export function ChevronIcon({
  /**
   * Controls the direction that the chevron is pointing
   */
  direction = 'down',
}: ChevronIconProps) {
  return (
    <div
      data-testid="chevron-icon-container"
      className={cn(
        'transition-transform duration-200',
        direction === 'up' && 'rotate-180',
      )}
    >
      <Icon type="chevron-down" size="sm" />
    </div>
  );
}

ChevronIcon.displayName = 'ChevronIcon';
